import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center mb-5" }
const _hoisted_2 = { class: "d-flex flex-column flex-sm-row ga-3 justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": _ctx.show,
    persistent: "",
    "max-width": "620"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        color: "surface",
        rounded: "lg",
        class: "pa-6"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_avatar, {
              color: "primary",
              variant: "tonal",
              rounded: "lg",
              size: "52",
              class: "mb-3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  icon: "mdi-rocket-launch-outline",
                  size: "28"
                })
              ]),
              _: 1
            }),
            _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "text-h5 font-weight-bold mb-2" }, "There’s a simpler way to work now", -1)),
            _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-body-2 text-medium-emphasis mb-0" }, [
              _createTextVNode(" We’ve added a streamlined "),
              _createElementVNode("strong", null, "Simple mode"),
              _createTextVNode(" — a friendlier workspace built on everything you already have. Your agents, workflows and schedules are all still here. ")
            ], -1))
          ]),
          _createVNode(_component_v_list, {
            class: "bg-transparent mb-2",
            density: "comfortable"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.highlights, (item) => {
                return (_openBlock(), _createBlock(_component_v_list_item, {
                  key: item.title,
                  class: "px-0"
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      icon: item.icon,
                      color: "primary",
                      class: "mr-3"
                    }, null, 8, ["icon"])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, { class: "font-weight-medium" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.title), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_list_item_subtitle, { class: "text-wrap" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.desc), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-caption text-medium-emphasis text-center mb-5" }, " You can switch back to Advanced anytime from the menu. ", -1)),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_v_btn, {
              color: "primary",
              variant: "flat",
              size: "large",
              onClick: _ctx.trySimple
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode(" Try Simple mode ")
              ])),
              _: 1,
              __: [2]
            }, 8, ["onClick"]),
            _createVNode(_component_v_btn, {
              variant: "text",
              size: "large",
              onClick: _ctx.dismiss
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("Maybe later")
              ])),
              _: 1,
              __: [3]
            }, 8, ["onClick"])
          ])
        ]),
        _: 1,
        __: [4]
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}